var map = {
	"./default.png": "/JHk",
	"./vip/default.png": "QhfZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fnfX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course ^\.\/.*default\.png$
// module id = fnfX
// module chunks = 1